import React, { useEffect, useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Environmental_Report_Filter from "./environmental_report_filter/Environmental_Report_Filter";
import Environmental_Report_Table from "./environmental_report_table/Environmental_Report_Table";
import {
  GetCustomerReport,
  GetEnviromentalReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../../features/admin/quality_management/resource_requirement/environmentcondition/Slice";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Environmental_Report = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const personaldetails = useSelector((state) => state.environmental_condition);
  const [searchParams, setSearchParams] = useState({
    instrument_id: "",
    instrument_name: "",
    end_date: "",
    start_date: "",
  });
  const authdetails = useSelector((state) => state.auth);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.environmental_report.Report);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: personaldetails.per_page,
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
    dispatch(GETAuthLogin());
  }, [dispatch, currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(GetEnviromentalReport({
        page:1,
        per_page: personaldetails.per_page,
        instrument_id: searchParams?.instrument_id,
        instrument_name: searchParams?.instrument_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }));

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Environmental_Report_Filter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setShow={setShow}
          reportgenerate={reportgenerate}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Environmental_Report_Table
          data={personaldetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Environmental Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Environmental_Report;
